import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "typeSelect",
    "searchContainer",
    "searchInput",
    "results",
    "ownerType",
    "ownerId",
    "currentOwner"
  ]
  static values = { url: String }

  connect() {
    this.timeout = null
    this.updateSearchVisibility()
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  typeChanged() {
    this.updateSearchVisibility()
    this.ownerIdTarget.value = ''
    this.searchInputTarget.value = ''
    this.clearResults()

    if (this.hasCurrentOwnerTarget) {
      this.currentOwnerTarget.style.display = 'none'
    }
  }

  updateSearchVisibility() {
    const hasType = this.typeSelectTarget.value !== ''
    this.searchContainerTarget.style.display = hasType ? 'block' : 'none'

    if (hasType) {
      this.ownerTypeTarget.value = this.typeSelectTarget.value
    } else {
      this.ownerTypeTarget.value = ''
    }
  }

  handleInput() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.searchInputTarget.value.trim()

    if (query.length < 2) {
      this.clearResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.search(query)
    }, 300)
  }

  async search(query) {
    const type = this.typeSelectTarget.value
    if (!type) return

    try {
      const url = `${this.urlValue}?query=${encodeURIComponent(query)}&type=${encodeURIComponent(type)}`
      const response = await fetch(url)
      const results = await response.json()

      this.displayResults(results)
    } catch (error) {
      console.error('Owner search error:', error)
      this.clearResults()
    }
  }

  displayResults(results) {
    this.resultsTarget.replaceChildren()

    if (results.length === 0) {
      const empty = document.createElement('div')
      empty.className = 'list-group-item text-muted'
      empty.textContent = 'No results found'
      this.resultsTarget.appendChild(empty)
      return
    }

    results.forEach(result => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'list-group-item list-group-item-action'

      const wrapper = document.createElement('div')
      wrapper.className = 'd-flex justify-content-between align-items-center'

      const content = document.createElement('div')
      const nameEl = document.createElement('strong')
      nameEl.textContent = result.name
      content.appendChild(nameEl)

      if (result.detail) {
        content.appendChild(document.createElement('br'))
        const detailEl = document.createElement('small')
        detailEl.className = 'text-muted'
        detailEl.textContent = result.detail
        content.appendChild(detailEl)
      }

      wrapper.appendChild(content)
      item.appendChild(wrapper)
      item.addEventListener('click', () => this.selectResult(result))
      this.resultsTarget.appendChild(item)
    })
  }

  selectResult(result) {
    this.ownerTypeTarget.value = result.type
    this.ownerIdTarget.value = result.id

    if (this.hasCurrentOwnerTarget) {
      this.currentOwnerTarget.querySelector('[data-name]').textContent = result.name
      this.currentOwnerTarget.querySelector('[data-details]').textContent = `${result.type}${result.detail ? ' | ' + result.detail : ''}`
      this.currentOwnerTarget.style.display = 'flex'
      this.currentOwnerTarget.classList.remove('alert-info')
      this.currentOwnerTarget.classList.add('alert-warning')
    }

    this.searchContainerTarget.style.display = 'none'
    this.typeSelectTarget.style.display = 'none'

    this.searchInputTarget.value = ''
    this.clearResults()
  }

  clearSelection(event) {
    event.preventDefault()

    this.ownerTypeTarget.value = ''
    this.ownerIdTarget.value = ''
    this.typeSelectTarget.value = ''
    this.typeSelectTarget.style.display = 'block'

    if (this.hasCurrentOwnerTarget) {
      this.currentOwnerTarget.style.display = 'none'
    }

    this.searchContainerTarget.style.display = 'none'
  }

  clearResults() {
    this.resultsTarget.replaceChildren()
  }
}
